var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestMetricsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9458_59502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 47
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 46.5,
    height: 46.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9458_59502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 39C21.7889 39 19.7102 38.5784 17.7638 37.7352C15.8171 36.892 14.1236 35.744 12.6834 34.2912C11.2431 32.8387 10.1025 31.1365 9.26147 29.1847C8.42049 27.2329 8 25.1573 8 22.9578C8 18.8206 9.35986 15.2377 12.0796 12.2091C14.799 9.18019 18.2111 7.44383 22.3158 7V10.5719C19.1871 10.9986 16.6128 12.3869 14.5928 14.737C12.5726 17.087 11.5625 19.8273 11.5625 22.9578C11.5625 26.4066 12.7756 29.3471 15.2017 31.7793C17.6275 34.2118 20.5603 35.4281 24 35.4281C25.9823 35.4281 27.8399 34.9961 29.5726 34.132C31.3054 33.2683 32.73 32.1176 33.8463 30.68L36.9297 32.4987C35.4462 34.5121 33.5816 36.099 31.336 37.2594C29.0904 38.4198 26.6451 39 24 39ZM38.6657 29.3747L35.5823 27.5885C35.8566 26.924 36.0676 26.1977 36.2156 25.4097C36.3635 24.6217 36.4375 23.8044 36.4375 22.9578C36.4375 19.7947 35.4166 17.0409 33.3747 14.6965C31.3332 12.3518 28.7697 10.9769 25.6842 10.5719V7C29.7134 7.3898 33.1067 9.10716 35.864 12.1521C38.6213 15.197 40 18.7989 40 22.9578C40 24.1311 39.8931 25.2596 39.6792 26.3431C39.4655 27.4267 39.1277 28.4372 38.6657 29.3747Z",
    fill: "#2BB39E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestMetricsIcon);
export default __webpack_public_path__ + "static/media/testMetricsIcon.757f95d42dbbf3edf92134458277dc1b.svg";
export { ForwardRef as ReactComponent };